import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const ZoneTypeFilter: ISourcingToolSearchFilter = {
  id: "zone-type-id",
  type: "checkbox",
  field: "sidebar.react.search_sidebar.zoning",
  must: ConstrainedListFilterMust.MATCH_ANY,
  values: [],
  mustOptions: [ConstrainedListFilterMust.MATCH_ANY, ConstrainedListFilterMust.MATCH_NONE],
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_US_FL],
};
